import { useSyncExternalStore } from 'react';
import { serviceStatusStore } from './service-status-instance';
import type { ServiceStatus } from './service-status';

/** Subscribe to the Admin service reachability status (drives the waking state). */
export function useServiceStatus(): ServiceStatus {
    return useSyncExternalStore(
        serviceStatusStore.subscribe,
        serviceStatusStore.getSnapshot,
        serviceStatusStore.getSnapshot,
    );
}
